var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3945 0.404297C8.72928 0.404297 0.894531 8.23963 0.894531 17.9043C0.894531 27.569 8.72986 35.4043 18.3945 35.4043C28.0592 35.4043 35.8945 27.569 35.8945 17.9043C35.8945 8.23963 28.0592 0.404297 18.3945 0.404297ZM14.3258 28.4043L14.3141 28.3926L14.3042 28.4043L6.14453 20.0043L10.2448 15.8253L14.3147 20.016L26.5647 7.40488L30.6445 11.6037L14.3258 28.4043Z",
    fill: "#52DD6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/GreenTick.2d2588d2577eac17a538c9ecfa2ac2e8.svg";
export { ForwardRef as ReactComponent };